<template>
	<div>
		<div class="content-header">
			<div class="content-header-inner">
				<h1 class="content-header-title">Investigations</h1>

				<div class="project-dropdown-wrap" v-if="projectListLoaded && allProjects.length > 0">
					<div class="project-dropdown-wrap-inner">
						<v-select
							placeholder="Projects/Domains"
							v-model="project"
							:options="allProjects"
							label="name"
							:reduce="(option) => option._id"
							:disabled="allProjects.length === 1"
						/>
					</div>
				</div>
			</div>
		</div>

		<section class="outer-pad">
			<Table
				class="investigate-table"
				:headings="tableHeadings"
				:items="table.items"
				:pages="table.pages"
				:page="table.page"
				:count="table.count"
				:loading="table.loading"
				:sorted="table.sorted"
				:searchSetup="searchSetup"
				name="investigations"
				@pagination="pagination"
				@sort="sort"
				@search="search"
				@selected="selected"
				@checkbox="checkbox"
				@selectInvestigation="selectInvestigation"
				@deleteInvestigation="deleteInvestigation"
				@addNew="addNew"
				addNewButtonLabel="Add Investigation"
				:loadingText="loadingText"
				:emptyLabel="emptyLabel"
				:emptySearch="emptySearch"
			/>
		</section>

		<InvestigateModal v-if="showInvestigate" @close="closeInvestigateModal" :project="project" :noProjectDisabled="true" :id="investigationId" />
	</div>
</template>

<script>
	import Vue from "vue";
	import ApiService from "./../services/api.service";
	import general from "./../utils/general";
	import { mapMutations, mapState, mapActions } from "vuex";
	import { TokenService } from "./../services/storage.service";
	import Table from "./../components/Table.vue";
	import TableButton from "./../components/Display/TableButton.vue";
	import InvestigateModal from "./../components/Investigate.vue";
	export default {
		name: "Investigate",
		components: {
			Table,
			InvestigateModal,
		},
		watch: {
			project: {
				immediate: true,
				handler(newVal, oldVal) {
					if (newVal !== oldVal) {
						this.getInvestigations();
					}
				},
			},
			allProjects: {
				handler(newVal, oldVal) {
					if (newVal.length) {
						let project = TokenService.getProject();
						if (project && this.allProjects.find((p) => p._id === project)) {
							this.project = project;
						}
					}
				}
			}
		},
		data() {
			return {
				showInvestigate: false,
				investigationId: null,
				table: {
					page: 1,
					sorted: { created: -1 },
					search: {},
					loading: true,
					items: [],
				},
				projects: {
					fetched: false,
					project: null,
					list: [],
				},
				project: null
			};
		},
		methods: {
			...mapMutations("general", ["updateLoadingText"]),
			...mapActions("general", ["loadProjects"]),
			deleteInvestigation({ _id, name }) {
				this.$dialog
					.confirm("Delete " + name + "?", { okText: "Yes", cancelText: "Cancel" })
					.then(
						function() {
							this.updateLoadingText("One moment...");

							ApiService.delete("investigate/" + _id)
								.then(
									function() {
										this.updateLoadingText();
										this.getInvestigations();
									}.bind(this)
								)
								.catch(
									function(err) {
										this.updateLoadingText();
									}.bind(this)
								);
						}.bind(this)
					)
					.catch(function() {});
			},
			closeInvestigateModal(info) {
				general.modalClose();

				this.showInvestigate = false;

				if (typeof info !== "undefined") {
					this.getInvestigations();
				}
			},
			getInvestigations() {
				this.table.loading = true;

				ApiService.get("investigate" + this.queryString)
					.then(
						function(info) {
							let s = this.table.search;

							Vue.set(this, "table", info.data);

							this.table.search = s;

							this.table.loading = false;

							this.updateLoadingText();

							if (typeof callback !== "undefined") callback();
						}.bind(this)
					)
					.catch(function(err) {}.bind(this));
			},
			selectInvestigation({ _id }) {
				this.investigationId = _id;
				this.showInvestigate = true;
			},
			addNew() {
				this.investigationId = null;
				this.showInvestigate = true;
			},
			checkbox() {},
			selected() {},
			sort(info) {
				Vue.set(this.table, "sorted", info);
				Vue.set(this.table, "page", 1);
				if (info.init) {
					delete this.table.sorted.init;
					return;
				}
				this.getInvestigations();
			},

			search(info) {
				this.table.page = 1;
				this.table.search = info;
				this.getInvestigations();
			},

			pagination(info) {
				this.table.page = info.page;
				this.getInvestigations();
			},
		},
		computed: {
			...mapState("general", ["projectList", "projectListLoaded"]),

			allProjects() {
				if ( !this.projectListLoaded ) return [];

				let projects = {};

				this.projectList.forEach( (p) => {
					let domain = new URL(p.url).hostname;
					projects[domain] = projects[domain] || { dataDive: null, rankTracking: [] };
					if ( p.isDataDivePrimary && p.hasDataDive ) {
						projects[domain].dataDive = p._id;
					}
					if ( p.hasRankTracking ) {
						projects[domain].rankTracking.push(p);
					}
				});

				let domains = Object.keys(projects), 
					rtn = [];

				domains.sort();

				domains.forEach( (domain) => {

					let p = projects[domain], _ids = [], l = [], doDD = !!p.dataDive;

					p.rankTracking.forEach( (rt) => {
						l.push({ _id: rt._id + '--rt', name: rt.name });
						_ids.push(rt._id);
					});

					if ( doDD ) {
						l.push({ _id: p.dataDive + '--dd', name: 'Data Dive', domain: domain });
						_ids.push(p.dataDive);
					}

					rtn.push({ _id: _ids.join(','), name: domain });
					l.map( (item) => {
						item.name = '-- ' + item.name;
					});

					rtn.push(...l);

				});

				return rtn;

			},

			sorting() {
				let sorted = this.table.sorted;

				let sortBy = Object.keys(sorted)[0],
					sortDirection = sorted[sortBy] === 1 ? "asc" : "desc";

				return { sortBy: sortBy, sortDirection: sortDirection };
			},
			queryString() {
				let queryString = [];

				Object.keys(this.table.search).forEach(
					function(k) {
						if (Array.isArray(this.table.search[k])) {
							if (this.table.search[k].length > 0) queryString.push(k + "=" + this.table.search[k].join(","));
						} else if (this.table.search[k] !== "" && this.table.search[k] !== null && this.table.search[k] !== "") {
							queryString.push(k + "=" + this.table.search[k]);
						}
					}.bind(this)
				);

				queryString.push("sortBy=" + this.sorting.sortBy + "&sortDir=" + this.sorting.sortDirection);

				queryString.push("page=" + this.table.page);

				let projectIds = [];

				if ( this.project ) {

					this.project.split(',').forEach( (p) => {
						projectIds.push(p.split('--')[0]);
					});

				}

				if (this.project) queryString.push("projectIds=" + projectIds.join(','));

				if (queryString.length > 0) return "?" + queryString.join("&");

				return "";
			},

			showUserDropdowns() {
				if (this.table && this.table.users && this.table.users.length > 0) {
					let rtn = false;

					this.table.users.forEach(
						function(user) {
							if (user.label !== "You") rtn = true;
						}.bind(this)
					);

					return rtn;
				}

				return false;
			},

			emptyLabel() {
				let p = this.allProjects.find((p) => p._id === this.projects.project);

				if (p) {

					let n = !!p.domain ? ( ' for ' + p.domain ) : '';
					
					return "There are no " + p.name.replace('-- ','') + " investigations" + n + " at the moment";

				}

				return this.allProjects.length > 0
					? "There are no investigations at the moment"
					: "You need to create a project before you can use this area";
			},

			emptySearch() {
				let p = this.allProjects.find((p) => p._id === this.projects.project);

				if (p) {

					let n = !!p.domain ? ( ' for ' + p.domain ) : '';
					
					return "There were no " + p.name.replace('-- ','') + " investigations" + n + " matching your search";

				}

				return "There were no investigations matching your search";
			},

			loadingText() {
				if (this.allProjects.length > 0 || !this.projectListLoaded) return "Loading investigations...";

				return "You need to create a project before you can use this area";
			},

			tableHeadings() {
				return {
					name: { value: "Name", click: "selectInvestigation", clickVars: ["_id"], sort: -1 },
					created: { value: "Created", dateFormat: "jS M Y", click: "selectInvestigation", clickVars: ["_id"], sort: -1 },
					status: { value: "Status", component: TableButton, event: "selectInvestigation", sort: -1 },
					project: { value: "Project/Domain" },
					notes: { value: "Notes", click: "selectInvestigation", clickVars: ["_id"] },
					filter: { value: "Filter Used", emptyCell: "N/A", click: "selectInvestigation", clickVars: ["_id"] },
					createdBy: { value: "Created By", hide: !this.showUserDropdowns },
					assignedTo: { value: "Assigned To", hide: !this.showUserDropdowns },
					delete: { value: "", component: TableButton, event: "deleteInvestigation", valueForFilter: "Delete" },
				};
			},
			searchSetup() {
				let searchSetup = {
					searchText: { type: "text", placeholder: "", showLabel: "Search By Name" },
					status: {
						type: "select",
						multi: true,
						showLabel: "Status",
						items: [
							{ value: 1, label: "Open" },
							{ value: 5, label: "In-Progress" },
							{ value: 10, label: "Complete" },
						],
					},
				};

				if (this.showUserDropdowns) {
					searchSetup.createdBy = { type: "select", multi: true, showLabel: "Created By", items: this.table.users };

					searchSetup.assignedTo = { type: "select", multi: true, showLabel: "Assigned To", items: this.table.users };
				}

				return searchSetup;
			},
		},
		created() {
			this.loadProjects();
		},
	};
</script>
<style lang="less" scoped>
	.project-dropdown-wrap {
		margin: 25px 10px;
		position: relative;
		height: 36px;

		.project-dropdown-wrap-inner {
			width: 100%;
			position: absolute;
			background-color: transparent;

			.v-select {
				.vs__clear {
					display: none;
				}
			}
		}
	}
	@media screen and (min-width: 768px) {
		.project-dropdown-wrap {
			width: 350px;
			margin: 10px;
			position: absolute;
			z-index: 4;
			right: 0;
			top: 0;
			.project-dropdown-wrap-inner {
				max-width: 300px;
				right: 0;
			}
		}
	}
	@media screen and (min-width: 1024px) {
		.project-dropdown-wrap {
			right: 14px;
			top: 12px;
		}
	}
</style>
